var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-btn",class:_vm.config.className},[(_vm.config.type === 'normal')?_c('span',{},[_vm._v(_vm._s(_vm.config.label))]):(_vm.config.type === 'countdown')?_c('span',{},[_vm._v(_vm._s(_vm.formatedCountdownPrefix)+_vm._s(_vm.config.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }